import { render, staticRenderFns } from "./income-report.vue?vue&type=template&id=18365892&scoped=true&"
import script from "./income-report.vue?vue&type=script&lang=js&"
export * from "./income-report.vue?vue&type=script&lang=js&"
import style0 from "./income-report.vue?vue&type=style&index=0&id=18365892&lang=less&scoped=true&"
import style1 from "./income-report.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18365892",
  null
  
)

export default component.exports